import { render, staticRenderFns } from "./FooterNotices.vue?vue&type=template&id=5d86d8bc&"
import script from "./FooterNotices.vue?vue&type=script&lang=js&"
export * from "./FooterNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports